// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_mbp","cls2":"Header-cls2_qUU Header-cls1_mbp"};